const localIngestPattern = /^Ingest started via rtsp from (127\.0\.0\.1|::1|localhost)$/i;
const liveIngestPattern = /^Ingest started via .+ from .+$/i;

const hiddenDetailKeys = new Set([
  'id',
  'ids',
  'userId',
  'user_id',
  'channelId',
  'channel_id',
  'playlistId',
  'playlist_id',
  'itemId',
  'item_id',
  'itemIds',
  'item_ids',
  'sessionId',
  'session_id',
]);

const truncateAuditValue = (value: unknown, maxLength = 48) => {
  const text = String(value ?? '').trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 3))}...`;
};

const formatKey = (key: string) =>
  key
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^./, (letter) => letter.toUpperCase());

const formatJsonDetails = (parsed: unknown) => {
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return '';
  const entries = Object.entries(parsed as Record<string, unknown>).filter(
    ([key, value]) => !hiddenDetailKeys.has(key) && value != null && String(value).trim() !== ''
  );

  if (entries.length === 0) return '-';
  if (entries.length === 1 && entries[0][0] === 'name') return truncateAuditValue(entries[0][1]);

  return entries
    .map(([key, value]) => `${formatKey(key)}: ${truncateAuditValue(Array.isArray(value) ? value.join(', ') : value)}`)
    .join(' | ');
};

export const formatAuditDetails = (details?: unknown) => {
  const rawValue = typeof details === 'string' ? details.trim() : details;
  if (!rawValue) return '-';
  if (typeof rawValue === 'object') return formatJsonDetails(rawValue);

  const value = String(rawValue).trim();
  if (!value) return '-';
  if (value.startsWith('{') && value.endsWith('}')) {
    try {
      const formatted = formatJsonDetails(JSON.parse(value));
      if (formatted) return formatted;
    } catch {
      // Fall through to plain-text formatting.
    }
  }
  if (localIngestPattern.test(value)) return 'Ingest started MediaBox';
  if (liveIngestPattern.test(value)) return 'Ingest started Live';
  return truncateAuditValue(value, 120);
};
